import React from 'react';

import { useAccount } from '../../fetchHooks/useAccount';
import useAccountId from '../../hooks/queryparams/useAccountId';
import { AccountActions } from '../AccountActions';
import AccountBSUMessage from '../AccountView/bsu/AccountBSUMessage';

const AccountViewActions: React.FC<{ className?: string }> = ({ className }) => {
    const accountId = useAccountId();
    const { data: account } = useAccount(accountId);
    const bsuAccountType = account?.type === 'BSU' || account?.type === 'BSU_PLUSS';

    return <>{bsuAccountType ? <AccountBSUMessage /> : <AccountActions className={className} account={account} />}</>;
};

export default AccountViewActions;
